/* ggs-hiw-doc.js - "How it works (documentary)". Ported 2026-09-24 from
   homepage-seed-language-v1/howitworks-doc/index.html by qa/port-doc-to-theme.js. */
(function(){
  'use strict';

  var TAU = Math.PI * 2;
  var DWELL = 5, SPOT = 0.6, STEP_T = 0.75, CAM_T = 1.4, DIM_T = 6, J0 = 0.35, LO = 0.45;
  var U = 1.575;   /* one unit of the A2 drawing, in plate px (A2's jar is 184 units wide, this plate's is 290 px) */

  function clamp(v, a, b){ return v < a ? a : v > b ? b : v; }
  function c01(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function lerp(a, b, t){ return a + (b - a) * t; }
  function damp(k, dt){ return 1 - Math.exp(-k * dt); }
  function rngFrom(seed){
    var a = seed >>> 0;
    return function(){
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function cubicBezier(x1, y1, x2, y2){
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    function sx(t){ return ((ax * t + bx) * t + cx) * t; }
    function sy(t){ return ((ay * t + by) * t + cy) * t; }
    function dx(t){ return (3 * ax * t + 2 * bx) * t + cx; }
    return function(x){
      if(x <= 0) return 0; if(x >= 1) return 1;
      var t = x, i;
      for(i = 0; i < 8; i++){
        var e = sx(t) - x; if(Math.abs(e) < 1e-5) return sy(t);
        var d = dx(t); if(Math.abs(d) < 1e-6) break; t -= e / d;
      }
      var lo = 0, hi = 1; t = x;
      for(i = 0; i < 24; i++){ if(sx(t) < x) lo = t; else hi = t; t = (lo + hi) / 2; }
      return sy(t);
    };
  }
  function bezierFrom(str, fb){
    var m = /cubic-bezier\(([^)]+)\)/.exec(str || '');
    if(!m) return fb;
    var p = m[1].split(',').map(parseFloat);
    if(p.length !== 4 || p.some(isNaN)) return fb;
    return cubicBezier(p[0], p[1], p[2], p[3]);
  }
  /* a value that eases between states on one of the site curves */
  function Tween(v){ this.v = v; this.from = v; this.to = v; this.t = 1; }
  Tween.prototype.set = function(to, snap){
    if(snap){ this.v = this.from = this.to = to; this.t = 1; return; }
    if(to === this.to) return;
    this.from = this.v; this.to = to; this.t = 0;
  };
  Tween.prototype.step = function(dt, dur, ease){
    if(this.t >= 1){ this.v = this.to; return this.v; }
    this.t = Math.min(1, this.t + dt / dur);
    this.v = lerp(this.from, this.to, ease(this.t));
    return this.v;
  };
  function mixRGB(a, b, t){ return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ',' + Math.round(lerp(a[1], b[1], t)) + ',' + Math.round(lerp(a[2], b[2], t)) + ')'; }
  function hit(a, b){ return a[0] < b[2] && a[2] > b[0] && a[1] < b[3] && a[3] > b[1]; }
  /* does the segment (x0,y0)-(x1,y1) pass through box b? (Liang-Barsky) */
  function segHit(x0, y0, x1, y1, b){
    var t0 = 0, t1 = 1, dx = x1 - x0, dy = y1 - y0;
    var p = [-dx, dx, -dy, dy], q = [x0 - b[0], b[2] - x0, y0 - b[1], b[3] - y0];
    for(var i = 0; i < 4; i++){
      if(p[i] === 0){ if(q[i] < 0) return false; }
      else { var r = q[i] / p[i]; if(p[i] < 0){ if(r > t1) return false; if(r > t0) t0 = r; } else { if(r < t0) return false; if(r < t1) t1 = r; } }
    }
    return t0 <= t1;
  }

  /* ---------- plate geometry: IMG_W/IMG_H, JAR_PCT, WICK_PCT, RIM_PCT lifted from ../interactive-room-doc ---------- */
  var IMG_W = 1792, IMG_H = 2240;
  var JAR_PCT = { left:32.37, right:48.55, top:30.58, bottom:49.55 };
  var WICK_PCT = { L:{x:37.44,y:34.96}, C:{x:40.12,y:33.93}, R:{x:43.30,y:34.96} };
  var RIM_PCT = 30.58;

  /* Flame loops, in plate px. Each loop is a 192x256 crop whose flame fills only 44-86% of the frame, so
     the room page's FLAME_RATIO box (sized to the flame itself) draws the loop's flame at about 40% of the
     photographed one and below it. These boxes were fitted on this plate for dir-b and checked at 3x:
     the loop's tip and base land on the flame already in the photograph. cx = flame center across the
     loop, cut = the loop's wick top. */
  var FLAME_BOX = {
    L:{ l:643.0, t:710.9, w:58.6, h:78.1, cx:45.6, cut:88 },
    C:{ l:694.2, t:682.4, w:58.2, h:77.6, cx:43.8, cut:85.5 },
    R:{ l:753.5, t:703.7, w:60.3, h:80.4, cx:38.5, cut:88 }
  };

  /* the drawn phase of each step. Steps 3 and 4 were swapped 2026-09-30 (Contact now comes before Fall),
     so step 3 plays the contact phase (4) and step 4 plays the fall (3). */
  function phOf(n){ return n === 3 ? 4 : n === 4 ? 3 : n; }

  function px(p){ return p / 100 * IMG_W; }
  function py(p){ return p / 100 * IMG_H; }

  /* flame tips (the wick x, and the tip height measured on the plate at 5x) */
  var TIPS = [[px(WICK_PCT.L.x), 748], [px(WICK_PCT.C.x), 714], [px(WICK_PCT.R.x), 742]];
  /* the jar is a solid: its silhouette (a hair wider than JAR_PCT) from the rim line to the foot */
  var JX0 = px(31.3), JX1 = px(49.2), JTOP = py(RIM_PCT), JFOOT = py(50.4);
  var JCX = (px(JAR_PCT.left) + px(JAR_PCT.right)) / 2;
  var JIN0 = px(34), JIN1 = px(46.5);                  /* the opening a wax particle rises out of */
  /* table top at the jar's depth: y = 49.5% + (x - 40%) * 0.06, for x in 8-66%; past that the floor is off-frame */
  var SX0 = px(8), SX1 = px(66);
  function surfY(x){ return py(49.5 + (x / IMG_W * 100 - 40) * 0.06); }
  /* the glass of water: free rings keep off it, and so does the chip when it can */
  var GX0 = px(50.7), GX1 = px(63.4), GY0 = py(28.8), GY1 = py(43.9);
  /* the air around the candle the rings drift in (above the table's back edge), and the column above the flames */
  var AX0 = px(10), AX1 = px(74), AY0 = py(14), AY1 = py(31.5);
  var COLY = 714 - 110 * U;

  /* camera per step: scale, and the plate point (percent) that lands at the stage center; step 4 is the default crop */
  var CAMS = [null, { s:1.9, x:40.5, y:33.5 }, { s:1.45, x:42, y:31 }, { s:1.15, x:44, y:40 }, { s:1, x:null, y:null }];
  /* the step sets the mix (continuous sim, no reset): emission and capture intervals, hang time, pull toward the column */
  var MIX = [null,
    { emit:[0.42, 0.55], cap:[1.6, 2.2], hang:[2.2, 4.5], pull:0.8 },
    { emit:[0.8, 1.0],  cap:[0.5, 0.8], hang:[2.0, 4.0], pull:1.4 },
    { emit:[0.9, 1.1],  cap:[0.7, 1.0], hang:[0.4, 1.4], pull:1.0 },
    { emit:[1.0, 1.3],  cap:[0.8, 1.1], hang:[2.5, 5.0], pull:0.8 }];
  var C_DOT = '#D3FA99', C_DOT_EDGE = '#3D5B34', C_RING = 'rgba(252,252,247,.85)', C_RING_EDGE = 'rgba(10,24,7,.35)', C_LEADER = 'rgba(252,252,247,.7)';
  var F40 = [164, 176, 161], F20 = [210, 216, 208];

  function init(root){
    var stage = root.querySelector('.hiwD__stage');
    var cam = root.querySelector('.hiwD__cam');
    var plate = root.querySelector('.hiwD__plate');
    var cv = root.querySelector('.hiwD__cv');
    var ctx = cv.getContext('2d');
    var rows = Array.prototype.slice.call(root.querySelectorAll('.hiwD__row'));
    var chip = root.querySelector('.hiwD__chip');
    var chipTxt = root.querySelector('.hiwD__chip-txt');
    var chipCol = root.querySelector('.hiwD__chip-col');
    var capBar = root.querySelector('.hiwD__cap');
    var capD = root.querySelector('.hiwD__cap-d');
    var capL = root.querySelector('.hiwD__cap-lb');
    var capLbox = root.querySelector('.hiwD__odo--l');
    var vids = Array.prototype.slice.call(root.querySelectorAll('.hiwD__flame'));

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduce = !!(mq && mq.matches);
    var fm = /#doc-step-([1-4])(-green)?/.exec(window.location.hash || '');
    var freeze = !!fm;
    var still = reduce || freeze;
    if(fm && fm[2]) root.classList.add('hiwD--green');
    if(still) root.classList.add('hiwD--still');

    var step = fm ? parseInt(fm[1], 10) : 1;
    var rnd = rngFrom(still ? 20260923 : ((Math.random() * 4294967295) >>> 0));
    function R(a, b){ return a + (b - a) * rnd(); }

    var cs0 = window.getComputedStyle(root);
    var ER = bezierFrom(cs0.getPropertyValue('--d-e-reveal'), cubicBezier(0.22, 0.61, 0.36, 1));
    var ES = bezierFrom(cs0.getPropertyValue('--d-e-settle'), cubicBezier(0.22, 1, 0.36, 1));
    var EX = bezierFrom(cs0.getPropertyValue('--d-e-step'), cubicBezier(0.85, 0, 0.23, 1));

    /* ---------- layout: the plate cover-fit into the stage at 50% 30% ---------- */
    var G = { W:0, H:0, k:1, rw:0, rh:0, ox:0, oy:0, dpr:1, bar:44, small:false };
    function layout(){
      var W = stage.clientWidth || 600, H = stage.clientHeight || 480;
      var changed = Math.abs(W - G.W) > 0.5 || Math.abs(H - G.H) > 0.5;
      var k = Math.max(W / IMG_W, H / IMG_H);
      G.W = W; G.H = H; G.k = k; G.rw = IMG_W * k; G.rh = IMG_H * k;
      G.ox = (W - G.rw) * 0.5; G.oy = (H - G.rh) * 0.3;
      G.dpr = Math.min(window.devicePixelRatio || 1, 3);
      capLayout();
      G.small = W < 560;
      cam.style.right = 'auto'; cam.style.bottom = 'auto';
      cam.style.width = G.rw.toFixed(2) + 'px'; cam.style.height = G.rh.toFixed(2) + 'px';
      plate.style.width = G.rw.toFixed(2) + 'px'; plate.style.height = G.rh.toFixed(2) + 'px';
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      vids.forEach(function(v){
        var b = FLAME_BOX[v.getAttribute('data-w')];
        v.style.left = (b.l * k).toFixed(2) + 'px'; v.style.top = (b.t * k).toFixed(2) + 'px';
        v.style.width = (b.w * k).toFixed(2) + 'px'; v.style.height = (b.h * k).toFixed(2) + 'px';
        v.style.setProperty('--fcx', b.cx + '%'); v.style.setProperty('--fcut', b.cut + '%');
      });
      var bw = Math.max(1, Math.round(W * G.dpr)), bh = Math.max(1, Math.round(H * G.dpr));
      if(cv.width !== bw) cv.width = bw;
      if(cv.height !== bh) cv.height = bh;
      if(changed || !view) camRefit();
    }

    /* ---------- camera: translate + scale on the wrapper, mirrored on the canvas ---------- */
    var camA = null, camB = null, camT = 1, camBase = null, view = null;
    var drift = { x:0, y:0, h:0, tx:0, ty:0, th:0 };
    function fit(c){
      /* the jar and its label stay clear of the caption bar */
      var lim = G.H - G.bar - 10, foot = c.ty + c.s * G.k * JFOOT;
      if(foot > lim) c.ty -= foot - lim;
      /* and the photograph always covers the stage */
      c.tx = clamp(c.tx, G.W - c.s * G.rw, 0);
      c.ty = clamp(c.ty, G.H - c.s * G.rh, 0);
      return c;
    }
    function lean(c, m){
      var cx = G.W / 2, cy = G.H / 2;
      return { s:c.s * m, tx:cx - (cx - c.tx) * m, ty:cy - (cy - c.ty) * m };
    }
    function camOf(n){
      var c = CAMS[n], s = c.s, tx, ty;
      if(c.x === null){ tx = G.ox; ty = G.oy; }
      else { tx = G.W / 2 - s * c.x / 100 * G.rw; ty = G.H / 2 - s * c.y / 100 * G.rh; }
      return fit({ s:s, tx:tx, ty:ty });
    }
    function camStep(){ return reduce ? 4 : step; }
    /* re-aim after a size or font change without cutting a move short */
    function camRefit(){
      var c = camOf(camStep());
      if(still){ camBase = camA = camB = c; camT = 1; }
      else if(!ent.started){ camBase = camA = camB = fit(lean(c, 1.04)); camT = 1; }   /* settles in with the entrance */
      else if(camT < 1){ camB = c; }
      else { camBase = camA = camB = c; }
      applyCam();
    }
    function camGo(){
      if(still){ camRefit(); return; }
      camA = camBase; camB = camOf(camStep()); camT = 0;
    }
    function applyCam(){
      var b = lean(camBase, 1 + 0.03 * drift.h);
      b.tx -= drift.x * 0.015 * G.W; b.ty -= drift.y * 0.015 * G.H;
      view = fit(b);
      cam.style.transform = 'translate(' + view.tx.toFixed(2) + 'px,' + view.ty.toFixed(2) + 'px) scale(' + view.s.toFixed(4) + ')';
    }
    function camTick(dt){
      if(camT < 1){
        camT = Math.min(1, camT + dt / CAM_T);
        var e = ES(camT);
        camBase = { s:lerp(camA.s, camB.s, e), tx:lerp(camA.tx, camB.tx, e), ty:lerp(camA.ty, camB.ty, e) };
      }
      var kd = damp(4.5, dt);   /* about .9s to settle */
      drift.x += (drift.tx - drift.x) * kd; drift.y += (drift.ty - drift.y) * kd; drift.h += (drift.th - drift.h) * kd;
      applyCam();
    }
    function scr(x, y){ return [view.tx + view.s * G.k * x, view.ty + view.s * G.k * y]; }
    function onView(p, m){ var q = scr(p.x, p.y); return q[0] > m && q[0] < G.W - m && q[1] > m && q[1] < G.H - G.bar - m; }
    function jarBox(pad){ var a = scr(JX0, JTOP), b = scr(JX1, JFOOT); return [a[0] - pad, a[1] - pad, b[0] + pad, b[1] + pad]; }

    /* ---------- simulation, in plate px ---------- */
    var rings = [], wax = [], T = 0, emitT = 0.2, emitI = -1, capCd = 0.8, spawnCd = 0;
    var ent = { started:false, t:0, done:false };
    function popCap(){ return G.small ? 14 : 24; }
    function freeTarget(){ return G.small ? 5 : 9; }
    function waxMax(){ return Math.round((step === 1 ? 8 : step === 2 ? 6 : 4) * (G.small ? 0.5 : 1)); }
    function landedMax(){ return G.small ? 2 : 3; }
    function total(){ return rings.length + wax.length; }
    function rr(){ return 4.5 / G.k; }                  /* ring radius: 4.5 css px at camera scale 1 */
    function sepD(){ return Math.max(42 * U, 3.5 * rr()); }
    function inJar(x, y, m){ return x > JX0 - m && x < JX1 + m && y > JTOP - m; }
    function inGlass(x, y, m){ return x > GX0 - m && x < GX1 + m && y > GY0 - m && y < GY1 + m; }
    function okAir(x, y){ return x > AX0 && x < AX1 && y > AY0 && y < AY1 && !inJar(x, y, rr() + 30 * U) && !inGlass(x, y, rr() + 12 * U); }
    /* steer out of a padded box (the glass) toward its nearest free side */
    function offGlass(r, m, gain){
      var l = r.x - (GX0 - m), rt = (GX1 + m) - r.x, up = r.y - (GY0 - m), mn = Math.min(l, rt, up);
      if(mn === up) return [0, -up * gain];
      return mn === l ? [-l * gain, 0] : [rt * gain, 0];
    }
    function mkRing(x, y){
      return { kind:'ring', x:x, y:y, vx:0, vy:0, st:'free', t:0, aT:0, delay:0, fill:0, dim:0, dimT:-1, sc:1,
               fo:new Tween(LO), seed:R(0, 100), hang:0, landX:0, landY:0, targeted:null, fade:1, landedAt:0,
               dead:false, sx:0, sy:0, gone:false };
    }
    function seedRings(){
      var n = freeTarget(), tries = 0, sep = sepD();
      while(rings.length < n && tries < 4000){
        tries++;
        var x = R(AX0, AX1), y = R(AY0, AY1);
        if(!okAir(x, y)) continue;
        var ok = true;
        for(var i = 0; i < rings.length; i++){ if(Math.hypot(rings[i].x - x, rings[i].y - y) < sep){ ok = false; break; } }
        if(!ok && tries < 3000) continue;
        var r = mkRing(x, y); r.delay = R(J0 - 0.25, J0 + 1.7); r.fo.set(tgtFocus(r), true); rings.push(r);
      }
    }
    function spawnWax(i){
      var t = TIPS[i];
      var w = { kind:'wax', x:t[0] + R(-1.5, 1.5), y:t[1] - 3, y0:t[1] - 3, inA:0, vx:(t[0] - JCX) * 0.3 + R(-7, 7) * U, vy:R(-46, -34) * U,
                age:0, life:R(4.6, 6.8), st:'rise', seed:R(0, TAU), a:0, out:false, fo:new Tween(LO), tg:null, dead:false };
      w.fo.set(tgtFocus(w), true);
      wax.push(w);
    }
    function join(r){ r.st = 'join'; r.t = 0; r.dimT = 0; r.targeted = null; }   /* dimming starts at contact */
    function startFall(r){
      r.st = 'fall'; r.t = 0; r.vy = Math.max(r.vy, 0) + 3 * U;
      var rad = rr() * 1.3, x0 = JX0 - rad - 6 * U, x1 = JX1 + rad + 6 * U, x = r.x;
      if(x < SX0 || x > SX1){ r.landX = x; r.landY = Infinity; return; }   /* past the table: it leaves the frame */
      if(x > x0 && x < x1) x = x < JCX ? x0 - R(6, 70) * U : x1 + R(6, 70) * U;   /* a little drift away from the jar */
      else x = x + R(-18, 18) * U;
      x = clamp(x, SX0, SX1);
      if(x > x0 && x < x1) x = x < JCX ? x0 - 4 : x1 + 4;
      for(var k = 0; k < 4; k++){
        var clash = false;
        for(var i = 0; i < rings.length; i++){
          var o = rings[i];
          if(o !== r && (o.st === 'land' || o.st === 'fall') && Math.abs(o.landX - x) < 2.4 * rad){ clash = true; break; }
        }
        if(!clash) break;
        x = clamp(x + (rnd() < 0.5 ? -1 : 1) * R(2.6, 4.4) * rad, SX0, SX1);
        if(x > x0 && x < x1) x = x < JCX ? x0 - R(4, 20) * U : x1 + R(4, 20) * U;
      }
      r.landX = x; r.landY = surfY(x) - rad * 0.8 + R(-1, 1.5) * U;
    }
    function tgtFocus(p){
      var s = phOf(step), st = p.st;
      if(p.kind === 'wax') return st === 'rise' ? (s === 1 ? 1 : LO) : (s === 2 ? 1 : LO);
      if(st === 'free') return s === 2 ? 1 : LO;
      if(st === 'join') return (s === 2 || s === 4) ? 1 : LO;
      if(st === 'hang') return s === 4 ? 1 : (s === 2 ? 0.7 : LO);
      if(st === 'fall') return (s === 3 || s === 4) ? 1 : LO;
      return s === 4 ? 0.8 : LO;   /* resting on the table */
    }

    function sim(dt){
      T += dt;
      var mx = MIX[phOf(step)], rad = rr(), i, j, r, w, d, dx, dy, tvx, tvy, kk;
      /* emission: one wax particle at a time, cycling the three flames */
      emitT -= dt;
      if(emitT <= 0){
        emitT += R(mx.emit[0], mx.emit[1]);
        if(wax.length < waxMax() && total() < popCap()){ emitI = (emitI + 1) % 3; spawnWax(emitI); }
      }
      capCd -= dt; spawnCd -= dt;

      /* wax: rises from the flame tip, slows as it climbs, wanders; may seek a ring */
      for(i = wax.length - 1; i >= 0; i--){
        w = wax[i]; w.age += dt;
        if(w.st === 'rise'){
          var ax = Math.sin(w.age * 1.7 + w.seed) * 15 * U + (w.x - JCX) * 0.2;
          w.vx += ax * dt; w.vx *= Math.exp(-0.35 * dt);
          w.vy += (-15 * U - w.vy) * damp(0.55, dt);
          if(!w.out) w.vy = Math.min(w.vy, -12 * U);
          if(w.out && capCd <= 0 && w.age > 0.6 && w.age < w.life - 1.2 && w.y < JTOP - 30 * U){
            var best = null, bd = 115 * U;   /* wider reach than A2: this air holds far fewer rings */
            for(j = 0; j < rings.length; j++){
              r = rings[j];
              if(r.st !== 'free' || r.targeted || r.aT < 0.9 || r.delay > 0) continue;
              if(r.y > JTOP - 30 * U) continue;   /* joins happen in the air above the candle, never through the jar */
              d = Math.hypot(r.x - w.x, r.y - w.y);
              if(d < bd){ bd = d; best = r; }
            }
            if(best){ w.st = 'seek'; w.tg = best; best.targeted = w; capCd = R(mx.cap[0], mx.cap[1]); }
          }
        } else {
          r = w.tg;
          if(!r || r.st !== 'free' || r.dead){ w.st = 'rise'; w.tg = null; if(r) r.targeted = null; }
          else {
            dx = r.x - w.x; dy = r.y - w.y; d = Math.hypot(dx, dy) || 1;
            var sp = 14 * U + d * 0.9; kk = damp(4.5, dt);
            w.vx += (dx / d * sp - w.vx) * kk; w.vy += (dy / d * sp - w.vy) * kk;
            if(d < rad + 1 / G.k){ join(r); w.dead = true; wax.splice(i, 1); continue; }
          }
        }
        w.x += w.vx * dt; w.y += w.vy * dt;
        if(!w.out){
          w.x = clamp(w.x, JIN0, JIN1);                       /* in the opening it only rises */
          if(w.y < JTOP - 2.6 / G.k) w.out = true;
        } else if(inJar(w.x, w.y, 3 / G.k)){
          w.y = JTOP - 3 / G.k; w.vy = Math.min(w.vy, 0);     /* back over the rim, never into the jar */
        }
        /* it fades in across the opening: faint over the jar, at full strength only once it clears the rim line */
        w.inA = Math.max(w.inA, w.out ? 1 : c01((w.y0 - w.y) / (w.y0 - JTOP)));
        w.a = Math.pow(w.inA, 2.5) * (w.st === 'rise' ? 1 - ER(c01((w.age - (w.life - 1.4)) / 1.4)) : 1);
        if(w.st === 'rise' && (w.age > w.life || w.y < 0 || w.x < 0 || w.x > IMG_W)){
          w.dead = true; wax.splice(i, 1);
        }
      }

      /* separation between rings drifting in the air (free, and joined ones hanging) */
      var sep = sepD();
      for(i = 0; i < rings.length; i++){ rings[i].sx = 0; rings[i].sy = 0; }
      for(i = 0; i < rings.length; i++){
        var a1 = rings[i]; if((a1.st !== 'free' && a1.st !== 'hang') || a1.delay > 0) continue;
        for(j = i + 1; j < rings.length; j++){
          var b1 = rings[j]; if((b1.st !== 'free' && b1.st !== 'hang') || b1.delay > 0) continue;
          dx = a1.x - b1.x; dy = a1.y - b1.y; d = Math.hypot(dx, dy);
          if(d < sep && d > 0.01){ var f = (sep - d) / sep * 9 * U; a1.sx += dx / d * f; a1.sy += dy / d * f; b1.sx -= dx / d * f; b1.sy -= dy / d * f; }
        }
      }

      var nFree = 0, landed = [];
      for(i = rings.length - 1; i >= 0; i--){
        r = rings[i];
        if(r.delay > 0){ r.delay -= dt; nFree++; continue; }
        r.t += dt;
        if(r.aT < 1) r.aT = Math.min(1, r.aT + dt / 1.4);
        if(r.dimT >= 0){ r.dimT += dt; r.dim = ER(c01(r.dimT / DIM_T)); }
        var slow = lerp(1, 0.45, r.dim), m;
        if(r.st === 'free'){
          nFree++;
          var s = r.seed, spd = 7.5 * U;
          var ang = Math.sin(r.x / U * 0.0085 + T * 0.06 + s) * 2.2 + Math.cos(r.y / U * 0.011 - T * 0.045 + s * 1.3) * 1.8 + s;
          tvx = Math.cos(ang) * spd; tvy = Math.sin(ang) * spd * 0.7;
          dx = JCX + (r.x < JCX ? -1 : 1) * 30 * U - r.x; dy = COLY - r.y; d = Math.hypot(dx, dy);
          if(d > 60 * U && d < 420 * U){ tvx += dx / d * 6 * U * mx.pull; tvy += dy / d * 4 * U * mx.pull; }
          if(r.x < AX0 + 30 * U) tvx += (AX0 + 30 * U - r.x) * 0.6;
          if(r.x > AX1 - 30 * U) tvx -= (r.x - (AX1 - 30 * U)) * 0.6;
          if(r.y < AY0) tvy += (AY0 - r.y) * 0.6;
          if(r.y > AY1) tvy -= (r.y - AY1) * 0.8;
          m = rad + 18 * U;
          if(inJar(r.x, r.y, m)){
            var pxo = r.x < JCX ? (JX0 - m - r.x) : (JX1 + m - r.x), pyo = JTOP - m - r.y;
            if(Math.abs(pyo) < Math.abs(pxo)) tvy += pyo * 1.4; else tvx += pxo * 1.4;
          }
          m = rad + 12 * U;
          if(inGlass(r.x, r.y, m)){ var gp = offGlass(r, m, 1.4); tvx += gp[0]; tvy += gp[1]; }
          tvx += r.sx; tvy += r.sy;
          if(r.targeted){   /* the wax particle draws it in */
            w = r.targeted; dx = w.x - r.x; dy = w.y - r.y; d = Math.hypot(dx, dy) || 1;
            tvx = tvx * 0.25 + dx / d * 16 * U; tvy = tvy * 0.25 + dy / d * 16 * U;
          }
          kk = damp(1.6, dt);
          r.vx += (tvx - r.vx) * kk; r.vy += (tvy - r.vy) * kk;
        } else if(r.st === 'join'){
          r.fill = ES(c01(r.t / 0.4)); r.sc = 1 + 0.3 * r.fill;
          r.vx *= Math.exp(-4 * dt); r.vy *= Math.exp(-4 * dt);
          if(r.t > 0.45){
            if(rnd() < 0.7){ r.st = 'hang'; r.t = 0; r.hang = R(mx.hang[0], mx.hang[1]); }
            else startFall(r);
          }
        } else if(r.st === 'hang'){
          r.fill = 1; r.sc = 1.3;
          tvx = Math.sin(T * 0.4 + r.seed) * 3 * U * slow + r.sx; tvy = Math.cos(T * 0.33 + r.seed * 1.7) * 2 * U * slow + r.sy;
          m = rad * 1.3 + 12 * U;
          if(inJar(r.x, r.y, m)){   /* out by the nearest way: up over the rim, or aside */
            var hx = r.x < JCX ? (JX0 - m - r.x) : (JX1 + m - r.x), hy = JTOP - m - r.y;
            if(Math.abs(hy) < Math.abs(hx)) tvy += hy * 0.8; else tvx += hx * 0.8;
          }
          m = rad * 1.3 + 8 * U;
          if(inGlass(r.x, r.y, m)){ var gh = offGlass(r, m, 0.8); tvx += gh[0]; tvy += gh[1]; }
          kk = damp(1.2, dt);
          r.vx += (tvx - r.vx) * kk; r.vy += (tvy - r.vy) * kk;
          if(r.t > r.hang) startFall(r);
        } else if(r.st === 'fall'){
          r.fill = 1; r.sc = 1.3;
          r.vy = Math.min(r.vy + 30 * U * dt, lerp(70, 44, r.dim) * U);   /* gentle acceleration; slower once dim */
          m = rad * 1.3 + 6 * U;
          var over = r.x > JX0 - m && r.x < JX1 + m;   /* still over the jar: clear it sooner */
          tvx = (r.landY === Infinity ? 0 : (r.landX - r.x) * (over ? 1.2 : 0.55)) + Math.sin(T * 0.9 + r.seed) * 4 * U * slow;
          r.vx += (tvx - r.vx) * damp(1.6, dt);
          if(over && r.y > JTOP - 30 * U - m){
            r.vx += (r.x < JCX ? -1 : 1) * 60 * U * dt; r.vy *= Math.exp(-1.2 * dt);
          }
          if(r.y >= r.landY){ r.y = r.landY; r.st = 'land'; r.t = 0; r.vx = 0; r.vy = 0; r.landedAt = T; }
          else if(r.landY === Infinity && r.y > py(52)){ r.st = 'out'; r.gone = true; }
        } else if(r.st === 'land'){
          landed.push(r);
          if(r.dimT < 0){ r.dimT = DIM_T; r.dim = 1; }
        } else if(r.st === 'out'){
          r.fade -= dt / 1.2;
          if(r.gone){ r.vy = Math.min(r.vy + 30 * U * dt, 44 * U); r.y += r.vy * dt; }   /* keeps falling as it leaves */
          if(r.fade <= 0){ r.dead = true; rings.splice(i, 1); continue; }
        }
        if(r.st === 'free' || r.st === 'join' || r.st === 'hang' || r.st === 'fall'){
          r.x += r.vx * dt; r.y += r.vy * dt;
          /* the jar is solid: nothing inside it. A falling particle over the jar stops on the rim line. */
          var rr0 = rad * r.sc + 2 / G.k;
          if(inJar(r.x, r.y, rr0)){
            var dl = r.x - (JX0 - rr0), drr = (JX1 + rr0) - r.x, du = r.y - (JTOP - rr0);
            if(du <= Math.min(dl, drr)){
              r.y = JTOP - rr0; r.vy = Math.min(r.vy, 0);
              if(r.st === 'fall'){ r.landX = r.x; r.landY = r.y; r.st = 'land'; r.t = 0; r.vx = 0; r.landedAt = T; }
            } else if(dl < drr){ r.x = JX0 - rr0; r.vx = Math.min(r.vx, 0); }
            else { r.x = JX1 + rr0; r.vx = Math.max(r.vx, 0); }
          }
        }
      }
      /* only a few rest on the table; the air holds more */
      landed.sort(function(a, b){ return a.landedAt - b.landedAt; });
      for(i = 0; i < landed.length; i++){
        if(landed.length - i > landedMax() || T - landed[i].landedAt > 12) landed[i].st = 'out';
      }
      /* new rings drift into focus so the air never empties */
      if(nFree < freeTarget() && spawnCd <= 0 && total() < popCap()){
        spawnCd = R(0.7, 1.3);
        for(var tries = 0; tries < 30; tries++){
          var x = R(AX0, AX1), y = R(AY0, AY1), ok = okAir(x, y);
          for(j = 0; ok && j < rings.length; j++){ if(Math.hypot(rings[j].x - x, rings[j].y - y) < sep) ok = false; }
          if(ok){ var nr = mkRing(x, y); nr.fo.set(tgtFocus(nr), true); rings.push(nr); break; }
        }
      }
    }
    /* the step governs the mix: moving to Fall (step 4) lets the hanging particles go sooner */
    function nudgeMix(){
      if(step === 4) rings.forEach(function(r){ if(r.st === 'hang') r.hang = Math.min(r.hang, r.t + R(0.2, 1.2)); });
    }
    function updFocus(dt, snap){
      var i, p;
      for(i = 0; i < rings.length; i++){ p = rings[i]; p.fo.set(tgtFocus(p), snap); p.fo.step(dt, SPOT, ER); }
      for(i = 0; i < wax.length; i++){ p = wax[i]; p.fo.set(tgtFocus(p), snap); p.fo.step(dt, SPOT, ER); }
    }

    /* ---------- annotation chip: follows one tracked particle per step ---------- */
    var chipS = { p:null, ax:0, ay:0, x:0, y:0, w:0, h:0, side:1, mode:'', init:false, hand:1, hx:0, hy:0,
                  box:1, bx:0, by:0, vis:new Tween(0) };
    var labelW = [0, 0, 0, 0], capW = [0, 0, 0, 0];
    function measureLabels(){
      var i, spans = chipCol.querySelectorAll('i');
      for(i = 0; i < spans.length; i++) labelW[i] = Math.ceil(spans[i].getBoundingClientRect().width) + 1;
      spans = capL.querySelectorAll('i');
      for(i = 0; i < spans.length; i++) capW[i] = Math.ceil(spans[i].getBoundingClientRect().width) + 1;
      chipTxt.style.width = labelW[step - 1] + 'px';
      capLbox.style.width = capW[step - 1] + 'px';
    }
    /* the caption stacks to two lines when one line cannot hold the longest step */
    function capLayout(){
      capBar.classList.remove('hiwD__cap--stack');
      var l = capBar.firstElementChild.getBoundingClientRect().width;
      var r = capBar.lastElementChild.getBoundingClientRect().width - capLbox.getBoundingClientRect().width + Math.max.apply(null, capW);
      var cs = window.getComputedStyle(capBar);
      var room = capBar.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if(l + (parseFloat(cs.columnGap) || 16) + r > room + 0.5) capBar.classList.add('hiwD__cap--stack');
      G.bar = capBar.offsetHeight || 44;
    }
    function airDimmed(p){ return p.kind === 'ring' && (p.st === 'join' || p.st === 'hang' || p.st === 'fall'); }
    function inPhase(p){
      if(!p || p.dead) return false;
      var ok, ph = phOf(step);
      if(step === 1) ok = p.kind === 'wax' && p.st === 'rise' && p.out && p.a > 0.35;
      else if(step === 2) ok = (p.kind === 'ring' && (p.st === 'free' || p.st === 'join') && p.aT > 0.8 && !(p.delay > 0)) || (p.kind === 'wax' && p.st === 'seek');
      else if(ph === 3) ok = p.kind === 'ring' && p.st === 'fall' && p.landY - p.y > 26 * U;
      else ok = p.kind === 'ring' && (p.st === 'hang' || p.st === 'join' || (p.st === 'fall' && p.landY - p.y > 50 * U) || p.st === 'land');
      return ok && onView(p, 24);
    }
    function pickChip(){
      var best = null, bs = -1e9, i, p, sc, q, cen, ph = phOf(step);
      if(step === 1){
        for(i = 0; i < wax.length; i++){
          p = wax[i]; if(!inPhase(p)) continue;
          q = scr(p.x, p.y); cen = Math.hypot(q[0] - G.W * 0.5, q[1] - G.H * 0.4) / G.W;
          sc = -Math.abs(p.age - 1.4) - cen * 2;
          if(sc > bs){ bs = sc; best = p; }
        }
        return best;
      }
      for(i = 0; i < rings.length; i++){
        p = rings[i]; if(!inPhase(p)) continue;
        q = scr(p.x, p.y); cen = Math.hypot(q[0] - G.W * 0.5, q[1] - G.H * 0.45) / G.W;
        if(step === 2) sc = (p.targeted ? 100 : 0) + (p.st === 'join' ? 40 : 0) - cen * 30;
        else if(ph === 3) sc = (Math.min(p.landY, py(60)) - p.y) / U / 20 - cen * 10;
        else sc = (p.st === 'hang' ? 60 : p.st === 'join' ? 30 : p.st === 'fall' ? 20 : 0) + (p.dim > 0.12 && p.dim < 0.9 ? 25 : 0) +
                  (p.st === 'hang' ? (p.hang - p.t) * 4 : 0) - cen * 20;
        if(sc > bs){ bs = sc; best = p; }
      }
      return best;
    }
    function pRad(p){ return (p.kind === 'wax' ? 2.6 : 4.5 * p.sc) * view.s; }
    function anchorOf(x, y, ax, ay){ return [clamp(ax, x, x + chipS.w), clamp(ay, y, y + chipS.h)]; }
    function updChip(dt, snap){
      var p = chipS.p;
      if(!inPhase(p)){
        var np = pickChip();
        if(np && np !== p){
          chipS.p = np;
          if(chipS.init && !snap){ chipS.hand = 0; chipS.hx = chipS.ax; chipS.hy = chipS.ay; }   /* hand over, eased */
        } else if(!np){ chipS.p = null; }
        p = chipS.p;
      }
      chipS.vis.set(p && (ent.done || still) ? 1 : 0, snap);
      chipS.vis.step(dt, 0.62, ER);
      if(p){
        var q = scr(p.x, p.y);
        if(!chipS.init || snap){ chipS.ax = q[0]; chipS.ay = q[1]; chipS.hand = 1; }
        else if(chipS.hand < 1){
          chipS.hand = Math.min(1, chipS.hand + dt / STEP_T);
          var e = EX(chipS.hand);
          chipS.ax = lerp(chipS.hx, q[0], e); chipS.ay = lerp(chipS.hy, q[1], e);
        } else { chipS.ax = q[0]; chipS.ay = q[1]; }
      }
      /* the chip sits on the particle's outer side, never over the jar or its label, and its leader never crosses the jar */
      var jb = jarBox(8), jl = jarBox(2), jc = (jb[0] + jb[2]) / 2, M = 16;
      if(chipS.side === 1 && chipS.ax < jc - 24) chipS.side = -1;
      else if(chipS.side === -1 && chipS.ax > jc + 24) chipS.side = 1;
      var cw = chip.offsetWidth, ch = chip.offsetHeight, ax = chipS.ax, ay = chipS.ay;
      chipS.w = cw; chipS.h = ch;
      var xmax = G.W - M - cw, ymax = G.H - G.bar - M - ch;
      function cand(side, kind){
        var tx = side === 1 ? ax + 30 : ax - 30 - cw, ty;
        if(kind === 'up') ty = ay - 30 - ch / 2;
        else if(kind === 'down') ty = ay + 26 - ch / 2;
        else if(kind === 'lift') ty = jb[1] - ch - 4;
        else ty = ay - ch / 2;
        tx = clamp(tx, M, xmax); ty = clamp(ty, M, ymax);
        var an = anchorOf(tx, ty, ax, ay), bx = [tx, ty, tx + cw, ty + ch];
        var ok = !hit(bx, jb) && !segHit(ax, ay, an[0], an[1], jl);
        return { x:tx, y:ty, ok:ok, clear:ok && !hit(bx, gb), key:side + kind };
      }
      var ga = scr(GX0, GY0), gz = scr(GX1, GY1), gb = [ga[0] - 6, ga[1] - 6, gz[0] + 6, gz[1] + 6];
      var s0 = chipS.side;
      if(s0 === 1 && ax + 30 + cw > G.W - M) s0 = -1;
      else if(s0 === -1 && ax - 30 - cw < M) s0 = 1;
      var list = [cand(s0, ay - 30 - ch / 2 < M ? 'down' : 'up'), cand(-s0, ay - 30 - ch / 2 < M ? 'down' : 'up'),
                  cand(s0, 'lift'), cand(s0, 'side'), cand(-s0, 'side')];
      var pick = null, i;
      for(i = 0; i < list.length && !pick; i++){ if(list[i].clear) pick = list[i]; }   /* clear of the jar and the glass */
      for(i = 0; i < list.length && !pick; i++){ if(list[i].ok) pick = list[i]; }      /* clear of the jar */
      if(!pick) pick = list[0];
      if(!chipS.init || snap){ chipS.x = pick.x; chipS.y = pick.y; chipS.box = 1; chipS.mode = pick.key; chipS.init = !!p; }
      else {
        if(pick.key !== chipS.mode || chipS.hand === 0){ chipS.mode = pick.key; chipS.box = 0; chipS.bx = chipS.x; chipS.by = chipS.y; }
        if(chipS.box < 1){
          chipS.box = Math.min(1, chipS.box + dt / STEP_T);
          var eb = EX(chipS.box);
          chipS.x = lerp(chipS.bx, pick.x, eb); chipS.y = lerp(chipS.by, pick.y, eb);
        } else { chipS.x = pick.x; chipS.y = pick.y; }
      }
      chip.style.transform = 'translate3d(' + chipS.x.toFixed(2) + 'px,' + chipS.y.toFixed(2) + 'px,0)';
      chip.style.opacity = chipS.vis.v.toFixed(3);
    }

    /* ---------- drawing: plate space through the camera, so marks scale with the zoom and stay crisp ---------- */
    function drawRing(r, u){
      var e = ER(r.aT) * r.fade * r.fo.v;
      if(r.delay > 0 || e < 0.004) return;
      var rad = 4.5 * u * r.sc, a = e * lerp(1, 0.35, r.dim), lw = lerp(1.25, 1.6, r.fill) * u;
      if(r.fill > 0.001){
        ctx.globalAlpha = a * r.fill; ctx.fillStyle = mixRGB(F40, F20, r.dim);
        ctx.beginPath(); ctx.arc(r.x, r.y, rad, 0, TAU); ctx.fill();
      }
      ctx.globalAlpha = a;
      ctx.lineWidth = 0.75 * u; ctx.strokeStyle = C_RING_EDGE;
      ctx.beginPath(); ctx.arc(r.x, r.y, rad + lw / 2 + 0.375 * u, 0, TAU); ctx.stroke();
      ctx.lineWidth = lw; ctx.strokeStyle = C_RING;
      ctx.beginPath(); ctx.arc(r.x, r.y, rad, 0, TAU); ctx.stroke();
    }
    function draw(){
      var d = G.dpr, v = view, u = 1 / G.k, i, w;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.setTransform(d * v.s * G.k, 0, 0, d * v.s * G.k, d * v.tx, d * v.ty);
      for(i = 0; i < rings.length; i++) drawRing(rings[i], u);
      for(i = 0; i < wax.length; i++){
        w = wax[i];
        var al = w.a * w.fo.v;
        if(al < 0.01) continue;
        ctx.globalAlpha = al;
        ctx.beginPath(); ctx.arc(w.x, w.y, 2.6 * u, 0, TAU);
        ctx.fillStyle = C_DOT; ctx.fill();
        ctx.lineWidth = u; ctx.strokeStyle = C_DOT_EDGE; ctx.stroke();
      }
      /* leader: a hairline ring around the tracked particle, joined to the chip (stage px) */
      ctx.setTransform(d, 0, 0, d, 0, 0);
      var vis = chipS.vis.v;
      if(vis > 0.01 && chipS.p && chipS.init){
        var p = chipS.p, rad = pRad(p) + 3.5 * (chipS.hand < 1 ? lerp(0.3, 1, EX(chipS.hand)) : 1);
        var an = anchorOf(chipS.x, chipS.y, chipS.ax, chipS.ay);
        var ddx = an[0] - chipS.ax, ddy = an[1] - chipS.ay, dd = Math.hypot(ddx, ddy) || 1;
        ctx.globalAlpha = vis;
        ctx.strokeStyle = C_LEADER; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.arc(chipS.ax, chipS.ay, rad, 0, TAU); ctx.stroke();
        if(dd > rad + 2){
          ctx.beginPath(); ctx.moveTo(chipS.ax + ddx / dd * rad, chipS.ay + ddy / dd * rad); ctx.lineTo(an[0], an[1]); ctx.stroke();
        }
      }
      ctx.globalAlpha = 1;
    }

    /* ---------- steps, rows, odometers ---------- */
    var autoT = 0, holdPtr = false, holdFocus = false, holdView = false, holdTouch = false, hoverTimer = 0;
    function held(){ return holdPtr || holdFocus || holdView || holdTouch; }
    function setOdo(){
      var y = 'translateY(' + (-(step - 1)) + 'em)';
      capD.style.transform = y; capL.style.transform = y; chipCol.style.transform = y;
      if(labelW[step - 1]) chipTxt.style.width = labelW[step - 1] + 'px';
      if(capW[step - 1]) capLbox.style.width = capW[step - 1] + 'px';
    }
    function progOf(n){ return rows[n - 1].querySelector('.hiwD__prog'); }
    function syncRows(){
      rows.forEach(function(row){
        var n = parseInt(row.getAttribute('data-step'), 10), on = n === step;
        row.classList.toggle('is-active', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function roll(n){
      if(still) return;
      var idx = rows[n - 1].querySelector('.hiwD__idx');
      idx.classList.remove('is-roll'); void idx.offsetWidth; idx.classList.add('is-roll');
      window.setTimeout(function(){ idx.classList.remove('is-roll'); }, 800);
    }
    function activate(n){
      if(n === step) return;
      var prev = step; step = n;
      var pp = progOf(prev);
      window.setTimeout(function(){ if(step !== prev) pp.style.transform = 'scaleX(0)'; }, 480);
      autoT = 0; progOf(n).style.transform = 'scaleX(0)';
      syncRows(); setOdo(); roll(n);
      chipS.p = null;   /* the chip hands over to the new phase */
      nudgeMix();
      camGo();
      if(still) redraw();
    }
    rows.forEach(function(row){
      var n = parseInt(row.getAttribute('data-step'), 10);
      row.addEventListener('mouseenter', function(){
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function(){ activate(n); }, 130);
      });
      row.addEventListener('mouseleave', function(){ window.clearTimeout(hoverTimer); });
      row.addEventListener('focus', function(){ activate(n); });
      row.addEventListener('click', function(e){ e.preventDefault(); window.clearTimeout(hoverTimer); holdTouch = true; activate(n); });
      row.addEventListener('keydown', function(e){
        var k = e.key;
        if(k === 'Enter' || k === ' ' || k === 'Spacebar'){ e.preventDefault(); holdTouch = true; activate(n); }
        else if(k === 'ArrowRight' || k === 'ArrowDown'){ e.preventDefault(); rows[n % 4].focus(); }
        else if(k === 'ArrowLeft' || k === 'ArrowUp'){ e.preventDefault(); rows[(n + 2) % 4].focus(); }
      });
    });
    root.addEventListener('pointerenter', function(e){ if(e.pointerType !== 'touch') holdPtr = true; });
    root.addEventListener('pointerleave', function(){ holdPtr = false; });
    root.addEventListener('focusin', function(){ holdFocus = true; });
    root.addEventListener('focusout', function(e){ if(!root.contains(e.relatedTarget)) holdFocus = false; });
    /* the camera drifts toward a mouse pointer over the stage, and returns on leave */
    stage.addEventListener('pointermove', function(e){
      if(still || e.pointerType !== 'mouse') return;
      var r = stage.getBoundingClientRect();
      drift.tx = clamp((e.clientX - (r.left + r.width / 2)) / (r.width / 2), -1, 1);
      drift.ty = clamp((e.clientY - (r.top + r.height / 2)) / (r.height / 2), -1, 1);
      drift.th = 1;
    });
    stage.addEventListener('pointerleave', function(){ drift.tx = 0; drift.ty = 0; drift.th = 0; });

    /* ---------- loop ---------- */
    var raf = 0, last = 0, visible = true, looping = false;
    function frame(ts){
      raf = window.requestAnimationFrame(frame);
      if(last && ts - last < 15) return;   /* capped at 60fps */
      var dt = last ? Math.min((ts - last) / 1000, 1 / 20) : 1 / 60;
      last = ts;
      if(ent.started){
        ent.t += dt; if(ent.t > 1.1) ent.done = true;
        sim(dt);
        if(ent.done && !held()){
          autoT += dt;
          if(autoT >= DWELL) activate(step % 4 + 1);
        }
        progOf(step).style.transform = 'scaleX(' + c01(autoT / DWELL).toFixed(4) + ')';   /* linear, like the field guide */
      }
      camTick(dt);
      updFocus(dt, false);
      updChip(dt, false);
      draw();
    }
    function redraw(){ applyCam(); updFocus(0, true); updChip(0, true); draw(); }
    function startLoop(){ if(looping || still) return; looping = true; last = 0; raf = window.requestAnimationFrame(frame); }
    function stopLoop(){ if(!looping) return; looping = false; window.cancelAnimationFrame(raf); }
    function syncVideos(){
      var play = !still && visible;
      vids.forEach(function(v){
        v.muted = true;
        if(play){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
        else { try { v.pause(); } catch(e){} }
      });
    }
    function startEntrance(){
      if(ent.started) return;
      ent.started = true;
      root.classList.add('hiwD--in');
      camGo();   /* the camera settles from a slight lean onto step 1 */
    }
    /* still frames: run the sim ahead until the frame reads as the step */
    function reads(n){
      var i, p, nw = 0, young = 0, nf = 0, seek = 0, fall = 0, air = 0, land = 0;
      for(i = 0; i < wax.length; i++){
        p = wax[i]; if(!onView(p, 24)) continue;
        if(p.st === 'rise' && p.out && p.a > 0.6){ nw++; if(p.age > 0.9 && p.age < 2.2) young++; }
        if(p.st === 'seek' && p.tg && Math.hypot(p.tg.x - p.x, p.tg.y - p.y) < 50 * U) seek++;
      }
      for(i = 0; i < rings.length; i++){
        p = rings[i]; if(!onView(p, 24)) continue;
        if(p.st === 'free') nf++;
        else if(p.st === 'join') seek++;
        if(p.st === 'fall' && p.landY - p.y > 60 * U) fall++;
        if(airDimmed(p) && p.dim > 0.5) air++;
        if(p.st === 'land') land++;
      }
      if(n === 1) return nw >= (G.small ? 3 : 5) && young >= 1 && nf >= 2;
      if(n === 2) return seek >= 1 && nf >= 4;
      if(n === 3) return fall >= 2;
      if(n === 4) return air >= 2 && land >= 1 && air > land;
      return nw >= 2 && fall >= 1 && air >= 1 && land >= 1;   /* reduced motion: one wide frame that holds every phase */
    }
    function prewarm(){
      ent.started = true; ent.t = 10; ent.done = true;
      rings.forEach(function(r){ r.delay = 0; r.aT = 1; });
      var i, n = reduce && !freeze ? 0 : step;
      for(i = 0; i < 14 * 60; i++) sim(1 / 60);
      for(i = 0; i < 30 * 60 && !reads(phOf(n)); i++) sim(1 / 60);
    }

    measureLabels();
    layout();
    seedRings();
    syncRows(); setOdo();
    root.classList.add('is-ready');
    syncVideos();
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){
      measureLabels(); capLayout(); camRefit(); chipS.init = false; if(still) redraw();
    });

    if(still){
      prewarm();
      redraw();
    } else {
      root.classList.add('hiwD--pre');
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){ if(e.isIntersecting) startEntrance(); });
        }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }).observe(root);
        new IntersectionObserver(function(es){
          es.forEach(function(e){
            visible = e.isIntersecting;
            holdView = e.intersectionRatio < 0.25;
            if(visible) startLoop(); else stopLoop();
            syncVideos();
          });
        }, { threshold: [0, 0.25] }).observe(root);
      } else { startEntrance(); startLoop(); }
      window.setTimeout(function(){ startEntrance(); if(visible) startLoop(); }, 1200);   /* failsafe */
    }

    var ro = window.ResizeObserver ? new ResizeObserver(function(){ layout(); chipS.init = false; if(still) redraw(); }) : null;
    if(ro) ro.observe(stage); else window.addEventListener('resize', function(){ layout(); chipS.init = false; if(still) redraw(); });
  }

  /* every instance on the page, once each; the theme editor re-renders a section in place */
  function boot(){
    var secs = document.querySelectorAll('.hiwD');
    for(var i = 0; i < secs.length; i++){
      if(secs[i].__hiwD) continue;
      secs[i].__hiwD = true;
      try { init(secs[i]); } catch(err){ secs[i].classList.remove('hiwD--pre'); if(window.console) console.error(err); }
    }
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();